import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Departments = () => (
  <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 14.6654V2.66536C4 2.31174 4.14048 1.9726 4.39052 1.72256C4.64057 1.47251 4.97971 1.33203 5.33333 1.33203H10.6667C11.0203 1.33203 11.3594 1.47251 11.6095 1.72256C11.8595 1.9726 12 2.31174 12 2.66536V14.6654H4Z"
      stroke="#ffffff"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99967 8H2.66634C2.31272 8 1.97358 8.14048 1.72353 8.39052C1.47348 8.64057 1.33301 8.97971 1.33301 9.33333V13.3333C1.33301 13.687 1.47348 14.0261 1.72353 14.2761C1.97358 14.5262 2.31272 14.6667 2.66634 14.6667H3.99967"
      stroke="#ffffff"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6H13.3333C13.687 6 14.0261 6.14048 14.2761 6.39052C14.5262 6.64057 14.6667 6.97971 14.6667 7.33333V13.3333C14.6667 13.687 14.5262 14.0261 14.2761 14.2761C14.0261 14.5262 13.687 14.6667 13.3333 14.6667H12"
      stroke="#ffffff"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66699 4H9.33366"
      stroke="#ffffff"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66699 6.66797H9.33366"
      stroke="#ffffff"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66699 9.33203H9.33366"
      stroke="#ffffff"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66699 12H9.33366"
      stroke="#ffffff"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default withDefaultStyles(Departments)
